export default {"src":"/_next/static/media/Group-25851.16f50eb2.svg","height":104,"width":104};